import { ITypedReduxAction } from '../../types/redux/actionType';
import { ESortType, ISort } from '../../types/sort';

export enum ESortActionTypes {
  SetSortOptions = 'SORT/SET_SORT_OPTIONS',
  SetActiveSort = 'SORT/SET_ACTIVE_SORT',
}

export type TSetSortOptionsType = ITypedReduxAction<ESortActionTypes.SetSortOptions, ISort[]>;
export type TSetActiveSortType = ITypedReduxAction<ESortActionTypes.SetActiveSort, ESortType>;

export type TSortActions = TSetSortOptionsType | TSetActiveSortType;
